import { FormHelperText, Grid2 } from "@mui/material";
import { CountryBox } from "./CountryBox";
import { useFormContext } from "react-hook-form";
import { useCustom, useTranslation } from "@refinedev/core";
import { MarketplaceListResponse } from "../../../../../hooks/useInitializeApp";
import { SyncrosaleLoader } from "../../../../../components/layout/components/SyncrosaleLoader";

export const CountrySelect = () => {
  const {
    formState: { errors },
  } = useFormContext();
  const { translate } = useTranslation();

  const { data, isLoading } = useCustom<MarketplaceListResponse>({
    url: "marketplace",
    method: "get",
  });

  const marketplaces = data?.data?.marketplaces ?? [];

  if (isLoading) {
    return <SyncrosaleLoader />;
  }

  const marketplaceList = marketplaces.filter(
    (marketplace) => !marketplace.storeName,
  );

  return (
    <>
      <Grid2
        gap={2}
        container
        spacing={{ xs: 2, md: 3 }}
        columns={{ xs: 4, sm: 8, md: 12 }}
        sx={{
          marginTop: "16px",
          paddingTop: "16px",
        }}
        gridAutoRows={1}
      >
        {(marketplaceList ?? []).map((country) => (
          <CountryBox key={country.countryCode} country={country} />
        ))}
      </Grid2>
      <FormHelperText
        error
        sx={{ color: "red", marginLeft: "12px", marginTop: "4px" }}
      >
        {errors.country
          ? translate("pages.stores.create.marketplace.error")
          : ""}
      </FormHelperText>
    </>
  );
};
